import { useEffect } from "react";
import WhyUs from "../components/WhyUs";
import Stats from "../components/Stats";
import CtaBanner from "../components/CtaBanner";
import PageHero from "../components/PageHero";
import { IMAGES, Reveal, Eyebrow } from "../lib/data";

const PRINCIPLES = [
  { key: "Precizie", text: "Fiecare tratament este planificat digital, cu o acuratețe microscopică." },
  { key: "Confort", text: "O experiență silențioasă și lipsită de anxietate, în ritmul tău." },
  { key: "Transparență", text: "Plan de tratament și pași clari, comunicați de la prima consultație." },
  { key: "Etică", text: "Relații pe termen lung cu pacienții noștri, nu soluții rapide." },
];

const DesprePage = () => {
  useEffect(() => {
    document.title = "Despre noi | MEDAS Stomatologie Timișoara";
  }, []);

  return (
    <>
      <PageHero
        eyebrow="Despre noi"
        title="Povestea MEDAS, din 2019"
        desc="O clinică de familie crescută alături de pacienții noștri — cu tehnologie modernă și aceeași grijă de la început."
      />
      <section className="py-16 lg:py-24 bg-white" data-testid="about-story">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <Eyebrow>Cum am început</Eyebrow>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">
              Zâmbete sănătoase din 2019
            </h2>
            <p className="text-[#6B5C43] mt-5 leading-relaxed">
              MEDAS Dental Point nu e doar o clinică, ci un loc gândit în jurul pacientului:
              tehnologie modernă, mult calm și grijă la fiecare detaliu.
            </p>
            <p className="text-[#6B5C43] mt-4 leading-relaxed">
              Am renunțat la atmosfera rece de cabinet. La noi intri într-un spațiu cald,
              în care fiecare tratament se face în ritmul tău.
            </p>
            <p className="text-[#6B5C43] mt-4 leading-relaxed">
              Ne vedem ca parteneri ai sănătății tale pe termen lung — nu ca pe o oprire
              între două dureri de dinți.
            </p>
            <div className="mt-8 space-y-5">
              {PRINCIPLES.map((m) => (
                <div key={m.key} className="flex gap-4 items-start" data-testid={`principle-${m.key.toLowerCase()}`}>
                  <span className="font-display font-extrabold text-[#A6823B] text-lg w-32 shrink-0">{m.key}</span>
                  <p className="text-sm text-[#4A3F2E] leading-relaxed border-l-2 border-[#EADFC6] pl-4">{m.text}</p>
                </div>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="rounded-3xl overflow-hidden shadow-2xl shadow-[#2A2521]/10 aspect-[4/3]">
              <img src="/hol/hol1.jpg" alt="Holul clinicii MEDAS Timișoara" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
            </div>
          </Reveal>
        </div>
      </section>
      <section className="pb-20 lg:pb-24 bg-white" data-testid="about-gallery">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal className="max-w-2xl">
            <Eyebrow>Clinica noastră</Eyebrow>
            <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">Un spațiu în care te simți bine</h2>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 lg:grid-cols-3 gap-4">
            {[
              { src: "/hol/hol2.jpg", alt: "Holul clinicii MEDAS" },
              { src: "/spatii/cabinet1.jpg", alt: "Cabinet stomatologic MEDAS" },
              { src: "/spatii/cabinet4.jpg", alt: "Cabinet dentar modern cu unit verde" },
              { src: "/spatii/baie2.jpg", alt: "Grup sanitar — zona de baie cu oglindă" },
              { src: "/spatii/cabinet5.jpg", alt: "Unit dentar și monitor cu radiografie" },
              { src: "/spatii/baie1.jpg", alt: "Grup sanitar cu faianță botanică" },
              { src: "/hol/hol3.jpg", alt: "Perete decorativ cu lambriuri de lemn" },
              { src: "/spatii/cabinet6.jpg", alt: "Cabinet de tratament cu lustre aurii" },
              { src: "/hol/hol4.jpg", alt: "Scara interioară a clinicii" },
            ].map((img, i) => (
              <Reveal key={img.src} delay={(i % 3) * 0.08}>
                <div className="rounded-2xl overflow-hidden shadow-lg shadow-[#2A2521]/10 aspect-[3/4]" data-testid={`gallery-image-${i}`}>
                  <img src={img.src} alt={img.alt} loading="lazy" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <Stats />
      <WhyUs />
      <CtaBanner />
    </>
  );
};

export default DesprePage;
